import OptionService from "./../../../services/OptionService";

export default {
  namespaced: true,
  state: {
    optionList: [],
    inputList: [],
    option: {},
    lang: null
  },
  mutations: {
    setOptionList: (state, list) => {
      state.optionList = list;
    },
    setInputList: (state, list) => {
      state.inputList = Object.keys(list).map(key => {
        if (list[key].type === "checkbox") {
          list[key].value = list[key].value !== "0";
        }
        return list[key];
      });
    },
    setOption: (state, data) => {
      state.option = data;
    },
    setLang: (state, data) => {
      state.lang = data;
    }
  },
  actions: {
    getOptionList: ({ commit, state }, params) => {
      const { lang } = state;
      return new Promise((resolve, reject) => {
        OptionService.optionList_Type({ ...params, lang })
          .then(res => {
            commit("setOptionList", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getInputList: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.inputList_Type(params)
          .then(res => {
            commit("setInputList", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    option: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.option_Type(params)
          .then(res => {
            commit("setOption", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    option_l: ({ commit }, params) => {
      return new Promise((resolve, reject) => {
        OptionService.option_l_Type(params)
          .then(res => {
            commit("setOption", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateInputList: ({ dispatch }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateInputList_Type(optionData)
          .then(res => {
            dispatch("option", optionData.optionSysName);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    addOption: ({ dispatch }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.addOption_Type(optionData)
          .then(res => {
            const { optionName, optionType } = optionData;
            dispatch("getOptionList", { optionName, optionType });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateOption: ({ dispatch, state }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateOption_Type(optionData)
          .then(res => {
            const { optionName, optionType } = optionData;
            dispatch("getOptionList", { optionName, optionType });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    deleteOption: ({ dispatch, state }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.deleteOption_Type(optionData)
          .then(res => {
            const { optionName, optionType } = optionData;
            dispatch("getOptionList", { optionName, optionType });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateOptionsQueue: ({ dispatch }, optionData) => {
      return new Promise((resolve, reject) => {
        OptionService.updateOptionsQueue(optionData)
          .then(res => {
            const { optionName, optionType } = optionData;
            dispatch("getOptionList", { optionName, optionType });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateInputsQueue: ({ commit }, inputList) => {
      return new Promise((resolve, reject) => {
        OptionService.updateInputsQueue(inputList)
          .then(res => {
            if (res.status === 200) {
              commit("setInputList", res.data);
              resolve(res);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
